import React from 'react';
import BeforeContainer from '../BeforeContainer';

/**
 * ThreeDLayout component - Handles the responsive layout structure
 * Separated from the main View3D component for better modularity
 */
const ThreeDLayout = ({ 
    inputView,
    isMobilePortrait,
    urls,
    sku_id,
    children 
}) => {
    if (!inputView) {
        return (
            <div className="w-full h-full">
                {children}
            </div>
        );
    }

    const containerClasses = isMobilePortrait 
        ? 'w-full h-full flex flex-col-reverse justify-end gap-4 px-5 py-2'
        : 'w-full h-full flex justify-start flex-row gap-4 px-5 py-2';

    const beforeContainerClasses = isMobilePortrait 
        ? 'w-full h-auto overflow-y-scroll'
        : 'w-[35%] md:w-[25%] h-auto overflow-y-scroll xl:overflow-y-hidden';

    const mainContentClasses = isMobilePortrait
        ? 'w-full h-fit'
        : 'h-full w-[65%] md:w-[75%] rounded-lg';

    const viewportClasses = isMobilePortrait
        ? 'h-[28vh] md:h-[70vh] lg:h-[90vh]'
        : 'h-[28vh] sm:h-[70vh] lg:h-[90vh]';

    return (
        <div className={containerClasses}>
            <div className={beforeContainerClasses}>
                <BeforeContainer urls={urls} skuId={sku_id} />
            </div>
            <div className={mainContentClasses}>
                <div className='text-xs text-left p-1 font-medium mb-[5px]'>
                    Output
                </div>
                <div className={`relative w-full ${viewportClasses} touch-none text-left overflow-hidden rounded-lg`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

export default ThreeDLayout; 